import React from 'react'

import helpers from 'helpers'

const useContractConfigs = (settings, setValue) => {
  const [checkSettings, setCheckSettings] = React.useState({
    invoiceInterval: !helpers.formatNumber.isNumber(settings.invoiceInterval),
    daysToGenerateNfe: !helpers.formatNumber.isNumber(
      settings.daysToGenerateNfe,
    ),
  })

  const handleChangeServiceTax = event => {
    setValue(
      'settings.generateServiceTaxInvoices',
      event.target.value === 'true' ? true : false,
    )

    if (event.target.value === 'false') {
      setValue('settings.daysToGenerateNfe', '')
      setValue('settings.fixedTaxInvoiceDescription', '')
      setCheckSettings(prevState => ({
        ...prevState,
        daysToGenerateNfe: true,
      }))
    }
  }

  const handleChangeSettings = (event, field, defaultValue) => {
    if (event.target.checked) {
      setValue(`settings.${field}`, '')
      setCheckSettings(prevState => ({
        ...prevState,
        [field]: true,
      }))
    } else {
      setValue(`settings.${field}`, String(defaultValue))
      setCheckSettings(prevState => ({
        ...prevState,
        [field]: false,
      }))
    }
  }

  return {
    checkSettings,
    handleChangeServiceTax,
    handleChangeSettings,
  }
}

export default useContractConfigs
